<template>
    <el-dialog
        center
        :close-on-click-modal="closeModal"
        :title="title"
        :visible.sync="show"
        @close="$emit('dialogclose')"
        width="77%%">
        <slot />
        <div slot="footer" v-if="btnShow">
            <el-button class="btn c1" type="primary" @click="confirm();">{{ btnName }}</el-button>
            <el-button class="btn c2" @click="close()">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import { createProps } from '@/utils/createProps'
    export default {
        data() {
            return {
                show: false
            }
        },
        props: {
            closeModal: createProps(true),
            btnShow: createProps(true),
            title: createProps(''),
            btnName: createProps('保存'),
        },
        methods: {
            open() {
                this.show = true;
            },
            close() {
                this.show = false;
            },
            confirm() {
                this.$emit('confirm')
            }
        }
    }
</script>

<style lang="less" scoped>
    /deep/ .el-dialog__body{
            padding: 25px 56px 30px 0;
    }
    /deep/ .el-dialog{
        max-height: 80%;
        overflow: auto;
    }
    .btn{
        padding: 0 17px;
        min-width: 78px;
        box-sizing: border-box;
        height: 30px;
        background: #EA5B24;
        border-radius: 4px;
        font-size: 16px;
        color: #FFFFFF;
    }
    .c1{
        background: #163C78;
        margin-right: 90px;
    }
    .c2{
        background: #BFBFBF;
    }
</style>